import styled from 'styled-components';
import { Grid as GridAtom } from 'components/atoms/grid';

export const GridContainer = styled.div`
  height: calc(100% - 64px);
  width: 100%;
  position: relative;
`;
export const Grid = styled(GridAtom)`
  .ag-react-container {
    > :not(:first-child) {
      display: none !important;
    }
    width: 100%;
    > div {
      width: 100%;
    }
  }
  .ag-row {
    border-bottom: 1px solid var(--border-color);
    .clickable-cell {
      cursor: pointer;
    }
  }
  .ag-row-odd {
    background-color: var(--ag-background-color, var(--white-100));
  }
  .ag-row-focus {
    background-color: var(--ag-background-color, var(--white-100));
  }
  .ag-row-hover {
    background: var(--ag-row-hover-color);
  }
  .ag-overlay-no-rows-wrapper {
    display: flex;
    text-align: unset;
    pointer-events: auto;
    align-items: flex-start;
    .ag-react-container {
      padding-left: var(--layout-06);
      padding-top: calc(
        calc(var(--layout-06) + var(--layout-03)) + var(--layout-02)
      );
    }
  }
  .ag-cell {
    padding: 0 var(--cell-padding);
  }
`;
